/**
 * File: navigation.js
 *
 * Handles navigation menu toggling, scroll behavior, and section highlighting.
 */

var Accordion = require("vanilla-js-accordion");
const body = document.querySelector("body");
const header = document.querySelector("header");
const menuToggle = document.querySelector("#menu-toggle");
const mobileNavLinks = document.querySelectorAll("#mobile-nav a");
const mainMenuItems = document.querySelectorAll("#main-menu .menu-item");
const sections = document.querySelectorAll("section[id]");

let lastScrollTop = 0;

let accordions = [];
var options = {
  item: ".menu-item-has-children",
  target: ".top-level",
  control: ".top-level",
  panel: ".sub-menu",
  allowMultiple: true,
  attribute: "data-status",
  expanded: "tab-open",
  contracted: "tab-closed",
  prefix: "accordion-",
  transition: "height .3s",
  setFocus: "none", // options: none, item, panel, target, control, first
  hashEnabled: false, // use hash in URL to open accordion item
};

// Scroll direction detection
window.addEventListener(
  "scroll",
  function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    body.classList.toggle("scroll-down", scrollTop > lastScrollTop);
    body.classList.toggle("scroll-up", scrollTop <= lastScrollTop);
    lastScrollTop = Math.max(scrollTop, 0);
  },
  false
);

// Add 'scrolled' class to body when scrolled past 90px
function toggleScrolledClass() {
  body.classList.toggle("scrolled", window.scrollY > 600);
}

window.addEventListener("scroll", toggleScrolledClass);

// Menu toggling functions
function toggleMenu() {
  body.classList.contains("menu-open") ? closeMenu() : openMenu();
}

function openMenu() {
    menuToggle.setAttribute("aria-expanded", "true");
    body.classList.add("menu-start");
    
    // Change text to "Close" when menu is opened
    const menuText = menuToggle.querySelector(".menu-text");
    if (menuText) menuText.textContent = "Close";
    
    // Toggle icons
    const barsIcon = menuToggle.querySelector('[data-icon="bars"]');
    const closeIcon = menuToggle.querySelector('[data-icon="close"]');
    if (barsIcon) barsIcon.classList.add("hidden");
    if (closeIcon) closeIcon.classList.remove("hidden");
  
    setTimeout(() => body.classList.add("menu-open"), 1);
    setTimeout(() => body.classList.add("menu-animate"), 50);
  }
  

document.querySelectorAll(".menu-accordion").forEach((i) => {
//   console.log(i);
  var sffeAccordion = new Accordion(i, options);
  accordions.push(sffeAccordion); // Add each accordion to the list
});

// Function lveas meun items requiring a double click and also can't handle sub items
function closeMenuItems() {
  // Select all elements with the specified class
  const menuItems = document.querySelectorAll(
    ".top-level.menu-item-has-children"
  );

  // Iterate over each element and update attributes
  menuItems.forEach((item) => {
    item.setAttribute("aria-expanded", "false");
    item.setAttribute("data-status", "tab-closed");
  });

//   console.log("All menu items have been closed.");
}

function closeMenu() {
    // Change text back to "Menu" when menu is closed
    const menuText = menuToggle.querySelector(".menu-text");
    if (menuText) menuText.textContent = "Menu";
    
    // Toggle icons back
    const barsIcon = menuToggle.querySelector('[data-icon="bars"]');
    const closeIcon = menuToggle.querySelector('[data-icon="close"]');
    if (barsIcon) barsIcon.classList.remove("hidden");
    if (closeIcon) closeIcon.classList.add("hidden");
  
    body.classList.remove("menu-start", "menu-animate");
    menuToggle.setAttribute("aria-expanded", "false");
    setTimeout(() => body.classList.remove("menu-open"), 200);
    setTimeout(() => {
      closeMenuItems();
    }, 500);
  }

// Event listeners
menuToggle?.addEventListener("click", toggleMenu);

// Smooth scroll function with offset

// Handle both same-page anchors and incoming hash links

// Handle clicks on anchor links within the page


/**
 * Dropdown Menu JavaScript
 * Handles hover and click events for WordPress navigation menus
 */
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-item.has-dropdown');
  
  menuItems.forEach(function(item) {
    console.log(item);
      const link = item.querySelector('a');
      const submenu = item.querySelector('.dropdown-menu');
      let hoverTimer;
      
      if (!submenu) return;
      
      // Mouse enter event
      item.addEventListener('mouseenter', function() {
          clearTimeout(hoverTimer);
          item.classList.add('dropdown-open');
          submenu.style.display = 'block';
          
          // Animate dropdown appearance
          submenu.style.opacity = '0';
          submenu.style.transform = 'translateY(10px)';
          
          setTimeout(function() {
              submenu.style.opacity = '1';
              submenu.style.transform = 'translateY(0)';
          }, 10);
      });
      
      // Mouse leave event
      item.addEventListener('mouseleave', function() {
          hoverTimer = setTimeout(function() {
              item.classList.remove('dropdown-open');
              submenu.style.opacity = '0';
              submenu.style.transform = 'translateY(10px)';
              
              setTimeout(function() {
                  submenu.style.display = 'none';
              }, 200);
          }, 100);
      });
      
      // Click event for mobile/touch devices
      link.addEventListener('click', function(e) {
          // Only prevent default if submenu exists and is currently hidden
          if (submenu && !item.classList.contains('dropdown-open')) {
              e.preventDefault();
              
              // Close other open dropdowns
              menuItems.forEach(function(otherItem) {
                  if (otherItem !== item) {
                      otherItem.classList.remove('dropdown-open');
                      const otherSubmenu = otherItem.querySelector('.dropdown-menu');
                      if (otherSubmenu) {
                          otherSubmenu.style.display = 'none';
                      }
                  }
              });
              
              // Toggle current dropdown
              item.classList.toggle('dropdown-open');
              if (item.classList.contains('dropdown-open')) {
                  submenu.style.display = 'block';
                  submenu.style.opacity = '1';
                  submenu.style.transform = 'translateY(0)';
              } else {
                  submenu.style.display = 'none';
              }
          }
      });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
      if (!e.target.closest('.menu-item.has-dropdown')) {
          menuItems.forEach(function(item) {
              const submenu = item.querySelector('.dropdown-menu');
              item.classList.remove('dropdown-open');
              if (submenu) {
                  submenu.style.display = 'none';
              }
          });
      }
  });
  
  // Handle keyboard navigation
  document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
          menuItems.forEach(function(item) {
              const submenu = item.querySelector('.dropdown-menu');
              item.classList.remove('dropdown-open');
              if (submenu) {
                  submenu.style.display = 'none';
              }
          });
      }
  });
  
  // Arrow key navigation within dropdowns
  menuItems.forEach(function(item) {
      const submenuLinks = item.querySelectorAll('.dropdown-menu a');
      
      submenuLinks.forEach(function(link, index) {
          link.addEventListener('keydown', function(e) {
              if (e.key === 'ArrowDown') {
                  e.preventDefault();
                  const nextLink = submenuLinks[index + 1];
                  if (nextLink) nextLink.focus();
              } else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  const prevLink = submenuLinks[index - 1];
                  if (prevLink) {
                      prevLink.focus();
                  } else {
                      item.querySelector('a').focus();
                  }
              }
          });
      });
  });
});